import { render, staticRenderFns } from "./IndexThree.vue?vue&type=template&id=5b77451c"
import script from "./IndexThree.vue?vue&type=script&lang=js"
export * from "./IndexThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports